<template>
  <div class="app-header">
    <div class="page-header">
      <div class="left-wrap">
        <i class="el-icon-back" @click="$router.push({ name: 'company-app-template' })"></i>
        <div class="app-info">
          <div class="name">
            {{ app.name }}
          </div>
          <div class="desc">
            {{ app.templateDesc }}
          </div>
        </div>
        <i class="el-icon-edit-outline pointer" @click="clickBtn('edit')"></i>
      </div>
      <tabs :tab-list="tabs" :default-active="defaultActive" @click="changeTab" class="tabs"></tabs>
      <div class="operate">
        <span class="last-update-time">
          最后更新时间：{{ _.get(app, "templateInfo.updateAt", "无") }}
        </span>
        <base-button
          v-if="app.templateInfo.status == '进行中'"
          type="primary"
          @click="clickBtn('save')"
        >
          保存为版本
        </base-button>
        <base-button
          v-else-if="app.templateInfo.status == '待发布'"
          type="primary"
          @click="clickBtn('publish')"
        >
          发布
        </base-button>
        <base-button @click="clickBtn('close')">关闭</base-button>
        <dropdown-menu
          @click="clickBtn"
          :menu-list="[
            { title: '灰度发布', command: 'gray-publish' },
            { title: '查看历史版本', command: 'history' },
            { title: '删除', command: 'delete' }
          ]"
          placement="bottom-end"
        >
          <base-button size="normal" style="width: 32px; padding: 0">
            <i class="el-icon-more"></i>
          </base-button>
        </dropdown-menu>
      </div>
    </div>
    <save-version-dialog
      ref="saveVersionDialog"
      :version-data="versionData"
      @refresh="refresh"
    ></save-version-dialog>
    <history-dialog ref="historyDialog"></history-dialog>
    <delete-template-dialog
      ref="deleteTemplateDialog"
      @refresh="clickBtn('close')"
    ></delete-template-dialog>
    <setting-template-dialog
      ref="settingTemplateDialog"
      @refresh="refresh"
    ></setting-template-dialog>
    <gray-publish-dialog ref="grayPublishDialog"></gray-publish-dialog>
  </div>
</template>

<script>
import Tabs from "@/components/UIComponents/Tab"
import { templateTabs } from "@/views/Front/Sheet/Layout/static"
import BaseButton from "@/components/UIComponents/Button"
import DropdownMenu from "@/components/UIComponents/DropdownMenu"
import SaveVersionDialog from "@/views/Company/Manage/App/TemplateDialogs/SaveVersionDialog"
import HistoryDialog from "@/views/Company/Manage/App/TemplateDialogs/HistoryDialog"
import DeleteTemplateDialog from "@/views/Company/Manage/App/TemplateDialogs/deleteTemplateDialog"
import SettingTemplateDialog from "@/views/Company/Manage/App/TemplateDialogs/SettingTemplateDialog"
import GrayPublishDialog from "@/views/Company/Manage/App/TemplateDialogs/GrayPublishDialog.vue"

export default {
  name: "AppHeader",
  components: {
    SettingTemplateDialog,
    BaseButton,
    DropdownMenu,
    Tabs,
    SaveVersionDialog,
    HistoryDialog,
    DeleteTemplateDialog,
    GrayPublishDialog
  },
  props: {
    app: {
      type: Object,
      required: true
    },
    defaultActive: String
  },
  data() {
    return {
      tabs: templateTabs,
      versionData: {}
    }
  },
  methods: {
    changeTab(tab) {
      let appId = this.app.id
      if (tab == "SheetList") {
        this.$router.replace({
          name: "worksheet",
          params: { appId },
          query: { template: "true" } // 用来初始化layout中的template变量默认值,防止标题栏闪烁
        })
      } else if (tab == "Setting") {
        this.$router.replace({
          name: "admin-app-info",
          params: { appId },
          query: { template: "true" } // 用来初始化layout中的template变量默认值,防止标题栏闪烁
        })
      }
    },
    clickBtn(btn) {
      switch (btn) {
        case "edit":
          this.$refs.settingTemplateDialog.open(this._.cloneDeep(this.app))
          break
        case "close":
          window.close()
          break
        case "save":
          this.$refs.saveVersionDialog.init(this.app.id, this.app.templateInfo?.version)
          break
        case "publish":
          this.$refs.settingTemplateDialog.open(this._.cloneDeep(this.app), true)
          break
        case "history":
          this.$refs.historyDialog.init(this.app)
          break
        case "delete":
          this.$refs.deleteTemplateDialog.init(this.app)
          break
        case "gray-publish":
          this.$refs.grayPublishDialog.open(this.app.id)
          break
      }
    },
    refresh() {
      this.$emit("refresh")
    }
  }
}
</script>

<style lang="scss" scoped>
.app-header {
  z-index: 1000;
  position: fixed;
  width: 100%;
  height: $navbar-height;
  top: 0;
  left: 0;
  .page-header {
    display: flex;
    position: relative;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 0 20px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
    background: #fff;
    .left-wrap {
      display: flex;
      align-items: center;
      .el-icon-back {
        margin-right: 15px;
        font-size: 20px;
        font-weight: bold;
        cursor: pointer;
        &:hover {
          color: #1e88e5;
        }
      }
      .app-info {
        margin-right: 15px;
        cursor: pointer;
        .name {
          font-size: 17px;
        }
        .desc {
          font-size: 12px;
          color: #9e9e9e;
        }
      }
    }
    .tab {
      position: absolute;
      left: 50%;
      ::v-deep {
        .tab-item {
          height: unset;
          .tab-title {
            height: unset;
            line-height: calc(#{$navbar-height} - 24px);
            padding: 10px;
          }
        }
      }
    }
    .operate {
      margin-left: auto;
      display: flex;
      align-items: center;
      .last-update-time {
        font-size: 12px;
        color: #9e9e9e;
      }
      .base-button {
        margin-right: 0;
        margin-left: 10px;
      }
    }
  }
}
</style>
